module.exports = __webpack_public_path__ + "img/viewer-menu-m.4595044f.svg";